import "./utils";
import "./components/smooth-scroll";
import "./components/section-reveal";
import "./components/scroll-parallax";
import "./components/home/who-we-are";
import "./components/home/medical-procedures";
import "./components/home/before-after-results";
import "./components/home/when-to-contact";
import "./popups/main";

if (document.querySelector(".swiper")) {
  import("./swipers/main").catch((error) => {
    console.error("Failed to load Swiper module:", error);
  });
}
import "../css/main.scss";
